export var toErrorType = function toErrorType(error, source) {
  if (source === void 0) {
    source = 'Unknown Source';
  }

  return {
    message: error instanceof Error || error.message ? error.message : typeof error === 'string' ? error : 'Unknown Error',
    source: source
  };
};